export enum AlertType {
	Mantenimiento = 'mantenimiento',
	PreITV = 'pre-itv',
	EntregaIdeal = 'entrega-ideal',
	OneToOnePolo = 'OneToOnePolo',
	OneToOneID = 'OneToOneID',
	Touran = 'Touran',
	GolfGTI = 'GolfGTI',
	IDWeCharge = 'IDWeCharge',
	IDWeChargePostPedido = 'IDWeChargePostPedido',
	VWBook26_Participa = 'VWBook26_Participa',
	VWBook26_Participado = 'VWBook26_Participado',
	VWBook26_Agotado = 'VWBook26_Agotado',
	Masters26_Open = 'Masters26_Open',
	Masters26_Enrolled = 'Masters26_Enrolled',
	LaLiga26_Open = 'LaLiga26_Open',
	LaLiga26_Enrolled = 'LaLiga26_Enrolled',
	LaLiga26_NoWinner = 'LaLiga26_NoWinner',
	ElClasico26_Open = 'ElClasico26_Open',
	ElClasico26_Enrolled = 'ElClasico26_Enrolled',
	ElClasico26_NoWinner = 'ElClasico26_NoWinner',
}

export interface Alert {
	type: AlertType;
	title: string;
	description: string;
}

export const alertsType: Alert[] = [
	{
		type: AlertType.Mantenimiento,
		title: '<h2>Recuerda que tu [modelo] tiene que <b>pasar por taller</b></h2>',
		description: '¡Toca sesión de cuidados para tu Volkswagen! Y viene con extra de tranquilidad para ti.',
	},
	{
		type: AlertType.PreITV,
		title: '<h2>Tu [modelo] tiene una cita: <b>la ITV</b></h2>',
		description: 'Y puedes llegar bien preparado con nuestra revisión pre-ITV.',
	},
	{
		type: AlertType.EntregaIdeal,
		title: '<h2><b>Resuelve todas tus dudas</b> con un experto en tu concesionario</h2>',
		description:
			'<b>Reserva cita para una sesión personalizada en concesionario,</b> donde uno de nuestros expertos te enseñará a sacarle el máximo partido a tu Volkswagen.',
	},
	{
		type: AlertType.OneToOnePolo,
		title: '<h2>¡Ven a disfrutar en la <b>Escuela GTI Safety Drive!</b></h2>',
		description:
			'La cita es en el circuito <b>RACC, Advanced Driving Center (Moraleja de Enmedio)</b> de Madrid este <b>15 de noviembre</b>.',
	},
	{
		type: AlertType.OneToOneID,
		title: '<h2><b>Escuela ID. 1to1: </b>disfruta de una experiencia de conducción única</h2>',
		description:
			'<b>Reserva tu plaza gratuita para poner a prueba tu ID.</b> junto a un piloto profesional y sácale el máximo partido a tu Volkswagen.',
	},
	{
		type: AlertType.Touran,
		title: '<h2>Touran. El familiar que va contigo, <b>desde 29.900€</b> sujeto a finaciación',
		description: 'Una nueva aventura empieza contigo al volante. ¡Súbete ahora!',
	},
	{
		type: AlertType.GolfGTI,
		title: '<h2>Demuestra que tienes Alma GTI y <b>consigue esta edición especial</b></h2>',
		description:
			' No es cualquier Golf GTI, es su versión más potente. <b>Solo habrá 325 unidades y tendrás que demostrar que tu pasión está a la altura si quieres uno.</b> ¿Te vas a quedar sin el tuyo?',
	},
	{
		type: AlertType.IDWeCharge,
		title: '<h2>Estrena eléctrico y <b>te invitamos a 10.000km de carga</b></h2>',
		description:
			'Pasarse al eléctrico es más fácil que nunca, porque elijas el modelo que elijas viene con lo mejor de Volkswagen y <b>hasta 10.000km estimados de carga pública en la red de We Charge</b>. Cortesía del Club Volkswagen ;)',
	},
	{
		type: AlertType.IDWeChargePostPedido,
		title: '<h2>A tus primeras cargas, <b>invitamos nosotros</b></h2>',
		description:
			'Lo prometido es deuda. Activa tu bono de carga para disfrutar de <b>hasta 10.000km estimados sin coste</b>. Sigue leyendo para descubrir cómo obtener tu saldo de carga en la app Volkswagen...',
	},
	{
		type: AlertType.VWBook26_Participa,
		title:
			'<h2>Un recorrido por la historia de Volkswagen a través de su diseño <b>¡Consigue tu libro de regalo!</b></h2>',
		description:
			'Como formas parte de la familia, queremos abrirte las puertas de nuestro estudio de diseño con esta <b>edición limitada del Libro de diseño de Volkswagen. </b>Date prisa, ¡no te quedes sin el tuyo!',
	},
	{
		type: AlertType.VWBook26_Participado,
		title: '<h2>Muy pronto podrás <b>disfrutar de tu libro</b></h2>',
		description:
			'Hemos recibido tu solicitud y en breve contactaremos contigo para darte todos los detalles para pasar a recogerlo ;)<br><br>Esperamos que este recorrido por la historia de Volkswagen, contado a través de su diseño, te inspire tanto como a nosotros.',
	},
	{
		type: AlertType.VWBook26_Agotado,
		title: '<h2>El Libro de diseño de Volkswagen <b>se ha agotado...</b></h2>',
		description:
			'¡Qué pena! Ya se ha agotado la <b>edición limitada del Libro de diseño de Volkswagen</b> que estábamos regalando. Pero sigue pendiente, porque pronto habrá más novedades en el club ;)',
	},
	{
		type: AlertType.Masters26_Open,
		title: '<h2><b>Conviértete en máster de la carretera</b></h2>',
		description:
			'Gana una de las 3 plazas gratuitas para nuestro máster exclusivo. <b>Durante 3 fines de semana, en 3 destinos distintos, tú y un acompañante</b> aprenderéis a dominar asfalto, nieve y hielo de la mano de pilotos expertos.<br><br>¿Tendrás lo necesario? <b>Apúntate y participa.</b>',
	},
	{
		type: AlertType.Masters26_Enrolled,
		title: '<h2>¿Serás tú? <b>Pronto saldrás de dudas</b></h2>',
		description:
			'<b>El proceso de selección ya está en marcha. </b>En caso de ser finalista, te contactaremos para continuar con la fase final. <b>¡Mucha suerte!</b>',
	},
	{
		type: AlertType.LaLiga26_Open,
		title: '<h2><b>Grita “gooool” con este sorteo especial de LALIGA</b></h2>',
		description:
			'<b>Celebra la pasión que sientes por tu equipo con el Club Volkswagen. <br/> <br/> Apúntate para ganar uno de los 20 premios en juego para los que viven el fútbol como tú. <b> ¡No te lo pierdas! </b>',
	},
	{
		type: AlertType.LaLiga26_Enrolled,
		title: '<h2><b>El balón está en nuestro campo</b></h2>',
		description:
			'<b>Ya estás dentro de nuestro sorteo de LALIGA</b>. Anunciaremos a los ganadores del sorteo el 30 de abril y nos pondremos en contacto contigo si ganas uno de los 20 premios.',
	},
	{
		type: AlertType.LaLiga26_NoWinner,
		title: '<h2>¡Lo sentimos! <b>Esta vez no has tenido la suerte del campeón</b></h2>',
		description: 'Sin embargo, <b>todavía queda mucha liga y más partidos por jugar.</b> ¡Mantente alerta! ',
	},

	{
		type: AlertType.ElClasico26_Open,
		title: '<h2>ELCLÁSICO de LALIGA EA SPORTS se empieza a jugar aquí: <b>participa por 1 entrada VIP doble</b></h2>',
		description:
			'<b>Vive la pasión de ELCLÁSICO de LALIGA EA SPORTS con el Club Volkswagen.</b><br/><br/> Apúntate al sorteo para ganar <b>una entrada VIP doble para el FC Barcelona vs. Real Madrid del 10 de mayo.</b> ¡No lo dejes escapar!',
	},
	{
		type: AlertType.ElClasico26_Enrolled,
		title: '<h2><b>El partido ya está en juego</b></h2>',
		description:
			'<b>Ya estás dentro del sorteo de ELCLÁSICO de LALIGA EA SPORTS.</b> Anunciaremos el resultado el 4 de mayo y nos pondremos en contacto contigo si eres la persona ganadora.',
	},
	{
		type: AlertType.ElClasico26_NoWinner,
		title: '<h2>¡Lo sentimos! <b>Esta vez no has tenido la suerte del campeón</b></h2>',
		description:
			'Sin embargo, <b>en el Club Volkswagen siempre hay algo más en juego esperándote.</b> ¡No te pierdas todo lo que está por venir!',
	},
];
